/**
 * @generated SignedSource<<bea8a59b31346739e0dc58f620e68467>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SelectPersonList_user$data = {
  readonly favourite_people: any;
  readonly id: number;
  readonly " $fragmentSpreads": FragmentRefs<"PersonSidePanel_user">;
  readonly " $fragmentType": "SelectPersonList_user";
};
export type SelectPersonList_user$key = {
  readonly " $data"?: SelectPersonList_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SelectPersonList_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SelectPersonList_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "favourite_people",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PersonSidePanel_user"
    }
  ],
  "type": "users",
  "abstractKey": null
};

(node as any).hash = "e1b9443a02be0e89464408b0d733ee52";

export default node;
